import {
  BankProductResponse,
  BankProductUpdateWithAccountDetailRequest,
} from '@b7hio/api-lib/src/ops-portal';
import { FeatureDialog } from '@b7hio/core-lib/src/components';
import { omit } from '@b7hio/core-lib/src/utils';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { UpdateProductForm } from '../ProductForm/UpdateProductForm';
import { ProductDocuments } from '../../hooks/useProductInteractivity';

interface Props {
  readonly open: boolean;
  readonly onClose: (event: object, reason: string) => void;
  readonly onSubmit: (
    bank: BankProductUpdateWithAccountDetailRequest,
    files: ProductDocuments
  ) => Promise<void>;
  readonly product: BankProductResponse;
}

export const ProductUpdateDialog = ({
  open,
  product: productRaw,
  onClose,
  onSubmit,
}: Props): JSX.Element => {
  const { t } = useTranslation(['products']);
  const product = omit(productRaw, [
    'productUid',
    'bank',
    'createdAt',
    'updatedAt',
    'feeDetails',
    'rateDetails',
    'proposalUid',
    'currentState',
  ]);

  return (
    <FeatureDialog
      id="ProductUpdateDialog"
      open={open}
      title={t('products:editProduct.title')}
      onClose={onClose}>
      <UpdateProductForm product={product} onSubmit={onSubmit} />
    </FeatureDialog>
  );
};
